import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Typography
} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CodeIcon from '@mui/icons-material/Code';

export const monoSx = { fontFamily: 'monospace', whiteSpace: 'pre-wrap', wordBreak: 'break-all', margin: 0 };

export const Code = ({ children }) => <Box component="span" sx={{ fontFamily: 'monospace' }}>{children}</Box>;

export const KeyValue = ({ label, md = 4, sx, children }) => (
  <Grid item xs={12} md={md}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Box sx={{ fontFamily: 'monospace', ...sx }}>{children}</Box>
  </Grid>
);

export const Stat = ({ icon, caption, md = 6, children }) => (
  <Grid item xs={12} md={md}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color: 'text.secondary', mb: 0.5 }}>
      {icon}
      <Typography variant="body2" color="inherit">{caption}</Typography>
    </Box>
    {children}
  </Grid>
);

export const SubLine = ({ children }) => <Typography color="text.secondary">{children}</Typography>;

export const RawJsonAccordion = ({ value }) => (
  <Accordion disableGutters elevation={0} sx={{ mt: 2, '&:before': { display: 'none' } }}>
    <AccordionSummary
      expandIcon={<ArrowRightIcon />}
      sx={{
        flexDirection: 'row-reverse',
        px: 0,
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': { transform: 'rotate(90deg)' },
        '& .MuiAccordionSummary-content': { alignItems: 'center', gap: 1, ml: 1 }
      }}
    >
      <CodeIcon fontSize="small" />
      <Typography>Raw JSON</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ px: 0 }}>
      <Box component="pre" sx={{ ...monoSx, bgcolor: 'grey.50', borderRadius: 2, p: 2 }}>
        {JSON.stringify(value, null, 2)}
      </Box>
    </AccordionDetails>
  </Accordion>
);
